import React, {createContext, ReactNode} from 'react';

export const TabContext = createContext<Omit<IProps, 'children'>>({name: ''});

interface IProps {
    children: ReactNode;
    name: string;
    activeTab?: string | null;
}

export const TabProvider = ({name, children, activeTab}: IProps) => {
    return <TabContext.Provider value={{activeTab, name}}>{children}</TabContext.Provider>;
};
